import { render, staticRenderFns } from "./liangxiang-assessment-report.vue?vue&type=template&id=2e993096&scoped=true"
import script from "./liangxiang-assessment-report.vue?vue&type=script&lang=js"
export * from "./liangxiang-assessment-report.vue?vue&type=script&lang=js"
import style0 from "./liangxiang-assessment-report.vue?vue&type=style&index=0&id=2e993096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e993096",
  null
  
)

export default component.exports